import {IApiEndpoints} from "../typings/apiEndpoints";
import {IApiMatch, IApiMatchResultReport, IApiMatchResultReportRound, IApiMatchMedia} from "../typings/apiResponse";
import {MatchQuery} from "./MatchQuery";
import * as angular from "angular";

export class MatchResource {
    public static $inject = ["$http", "ApiEndpoints", "$q"];
    constructor(
        private $http:angular.IHttpService,
        private ApiEndpoints:IApiEndpoints,
        private $q:angular.IQService
    ) {}

    public getMatchesForLeague(leagueId:number): angular.IPromise<IApiMatch[]> {
        return this.$http.get(this.ApiEndpoints.league + '/' + leagueId + '/matches')
            .then(matchesResponse => matchesResponse.data as IApiMatch[])
    }

    public getMatchesInRound(leagueId:number, round:number): angular.IPromise<IApiMatch[]> {
        return this.$http.get(this.ApiEndpoints.league + '/' + leagueId + '/matches?round=' + round)
            .then(matchesResponse => matchesResponse.data as IApiMatch[]);
    }

    public getMatch(id: number): angular.IPromise<IApiMatch> {
        return this.$http.get(this.ApiEndpoints.match + '/' + id)
            .then(matchResponse => matchResponse.data as IApiMatch);
    }

    public getMatchesForLoggedInUser(matchQuery?: MatchQuery): angular.IPromise<IApiMatch[]>{

        const requestParameters: any = {};

        if (matchQuery) {
            if (matchQuery.leagueIds) {
                requestParameters.leagueIds = matchQuery.leagueIds.join(',');
            }

            if (matchQuery.states) {
                requestParameters.state = matchQuery.states.join(',');
            }

            if (matchQuery.gameIds) {
                requestParameters.gameIds = matchQuery.gameIds.join(',');
            }

            if (matchQuery.limit) {
                requestParameters.limit = matchQuery.limit;
            }
        }

        return this.$http.get(this.ApiEndpoints.user + '/~/matches', {params: requestParameters})
            .then(matchResponse => matchResponse.data as IApiMatch[])
    }

    public getMatchResultReport(matchId: number): angular.IPromise<IApiMatchResultReport> {
        return this.$http.get(this.ApiEndpoints.match + '/' + matchId + '/result')
            .then(response => response.data as IApiMatchResultReport)
    }

    public postMatchResultReport(matchId: number, rounds: IApiMatchResultReportRound[], opponentAbsent: boolean): angular.IPromise<IApiMatch> {
        const resultDocument = {
            contestants: {
                opponent: {
                    absent: opponentAbsent
                },
                self: {
                    credibility: 5
                }
            },
            rounds: rounds
        };

        return this.$http.post(this.ApiEndpoints.match + '/' + matchId + '/result', resultDocument)
            .then(response => response.data as IApiMatch);
    }

    /**
     * Upload matchmedia to a match
     * This method supports progress reporting inside the promise. E.g.
     *
     * ```
     * matchRoesource.uploadMatchmedia(..., console.info.bind(console, "Progress:")).then(
     *   console.log.bind(console, "Success:"),
     *   console.error.bind(console, "Error:"),
     * )
     * ```
     *
     * @param matchId
     * @param file
     */
    public uploadMatchmedia(matchId: number, file: File, notify?: (progress: number) => void): angular.IPromise<any> {
        const formData = new FormData();

        formData.append('title', file.name);
        formData.append('file', file, file.name);

        return this.$http({
            method: "POST",
            data: formData,
            url: this.ApiEndpoints.match + '/' + matchId + '/media',
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            },
            uploadEventHandlers: {
                progress: (e: any) => {
                    if (notify) {
                        notify(e.loaded * 100 / e.total);
                    }
                }
            }
        });
    }

    public getMatchmedia(matchId: number): angular.IPromise<IApiMatchMedia[]> {
        return this.$http.get(this.ApiEndpoints.match + '/' + matchId + '/media')
            .then(matchMediaResponse => matchMediaResponse.data as IApiMatchMedia[]);
    }
}
